<template>
  <v-dialog persistent v-model="isShowModal" max-width="900px">
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex xs10 offset-xs1 class="py-5 px-5 ">
            <h3 v-if="token" class="text-xs-center py-2 my-2">
              Token:
              <a class="wordBreak" target="_blank" :href="`${eventLink}listing?token=${token}`">
                {{`${eventLink}listing?token=${token}`}}
              </a>
            </h3>
            <v-flex v-else xs6 offset-xs3 class="text-xs-center">
              <h3>
                This listing hasn`t Token
              </h3>
            </v-flex>
          </v-flex>
          <v-flex class="text-xs-center py-2 mt-4">
            <v-btn
              color="blue darken-1"
              flat="flat"
              @click="closeModal"
            >
              close
            </v-btn>
          </v-flex>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'showTokenModel',
    props: {
      isShow: {
        default: false,
        required: true,
        type: Boolean
      },
      token: {
        type: String
      }
    },
    data () {
      return {
        isShowModal: false
      }
    },
    computed: {
      ...mapGetters(['eventLink'])
    },
    watch: {
      isShow: {
        handler () {
          this.isShowModal = this.isShow
        },
        immediate: true,
      },
      isShowModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style>
  .wordBreak {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/showTokenModel.vue